module.exports = __webpack_public_path__ + "img/loan_img_1.1d9bae1f.png";